import { createReducer, updateObject } from './reducerUtilities';
import { ADD_TERMINALS_SEARCH_CRITERIA, ADD_PARTS_SEARCH_CRITERIA, ADD_STATIONS_SEARCH_CRITERIA, ADD_COMPANIES_SEARCH_CRITERIA, ADD_USERS_SEARCH_CRITERIA } from '../actions/actionTypes';

const initialState = {
  terminals: {
    terminalcode: '',
    numberofparts: '',
    location: '',
    status: '',
    comment: ''
  },
  parts: {
    serialnumber: '',
    status: '',
    location: '',
    parttype: '',
    terminalcode: '',
    comment: ''
  },
  stations: {
    pumpnumber: '',
    stationCode: '',
    name: '',
    address: '',
    city: ''
  },
  companies: {
    name: '',
    address: '',
    city: ''
  },
  users: {
    name: '',
    email: '',
    role: '',
    company: ''
  }
};

// Slice reducer
export const searchReducer = createReducer(initialState, {
   [ADD_TERMINALS_SEARCH_CRITERIA]: addTerminalsSearchCriteria,
   [ADD_PARTS_SEARCH_CRITERIA]: addPartsSearchCriteria,
   [ADD_STATIONS_SEARCH_CRITERIA]: addStationsSearchCriteria,
   [ADD_COMPANIES_SEARCH_CRITERIA]: addCompaniesSearchCriteria,
   [ADD_USERS_SEARCH_CRITERIA]: addUsersSearchCriteria
});

// Case reducers
function addTerminalsSearchCriteria(state, action) {
   return {
      ...state, terminals: updateObject(
         state.terminals, {...action.data}
         )
   };
}

function addPartsSearchCriteria(state, action) {
  return {
     ...state, parts: updateObject(
        state.parts, {...action.data}
        )
  };
}

function addStationsSearchCriteria(state, action) {
  return {
     ...state, stations: updateObject(
        state.stations, {...action.data}
        )
  };
}

function addCompaniesSearchCriteria(state, action) {
  return {
     ...state, companies: updateObject(
        state.companies, {...action.data}
        )
  };
}

function addUsersSearchCriteria(state, action) {
  return {
     ...state, users: updateObject(
        state.users, {...action.data}
        )
  };
}



// WEBPACK FOOTER //
// ./src/reducers/searchReducer.js